import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import BioPopup from '../components/BioPopup';
import PageHeader from '../components/PageHeader';

// Import team member images
import profAmazigoImg from '../assets/TEAM MEMBERS/Prof Uche Amazigo FAS.avif';
import profEneObongImg from '../assets/TEAM MEMBERS/Professor H. Ene-Obong FAS.avif';
import barristerOnuboguImg from '../assets/TEAM MEMBERS/Barrister C. Onubogu.avif';
import onyekaOnwenuImg from '../assets/TEAM MEMBERS/Onyeka Onwenu (MFR).avif';
import drNjepuomeImg from '../assets/TEAM MEMBERS/Dr. Ngozi Njepuome.avif';
import profEkwunifeImg from '../assets/EKWUNIFE/Prof Ekwunife.png';
import mrsAmarachiImg from '../assets/TEAM MEMBERS/Mrs Amarachi.avif';
import profCrumpImg from '../assets/TEAM MEMBERS/Professor Andy Crump.avif';
import profOnyegegbuImg from '../assets/TEAM MEMBERS/Professor Nkadi Onyegegbu.avif';
import profOkeibunorImg from '../assets/TEAM MEMBERS/Professor Joseph Okeibunor.avif';
import drEgbucheImg from '../assets/EKWUNIFE/Dr. Chukwudi Michael Egbuche.jpg';
import drAsiegbuImg from '../assets/EKWUNIFE/Prof. Emmanuel Chidubem Asiegbu.png';
import obiakorImg from '../assets/EKWUNIFE/OBIAKOR UGOCHUKWU ANTHONY.jpg';

const teamMembers = {
  boardOfTrustees: [
    {
      name: 'Prof Uche Amazigo FAS',
      title: 'Chair, BOT',
      role: 'Founder and CEO of Goodwill Medical Centre',
      bio: 'Professor Uche Amazigo is the founder/CEO of PACIEH. She is retired Director of the World Health Organization African Programme for Onchocerciasis {River blindness} is one of the few Africans to have led a specialized UN Agency, overseeing a highly successful multilateral partnership in global health. Uche was a Takemi Fellow at the Harvard School of Public Health (USA). She has devoted most of her academic, public and international career to research, sustainable community-driven health interventions, strengthening health systems and the elimination of neglected tropical diseases {NTD). In 2012, Uche Amazigo won the prestigious Prince Mahidol Laureate in Public Health.',
      imagePath: profAmazigoImg
    },
    {
      name: 'Professor H. Ene-Obong FAS',
      title: 'Board Member',
      bio: 'Prof. Henriette Ene-Obong is a Professor of Human Nutrition and Head, Department of Human Nutrition and Dietetics, Faculty of Basic Medical Sciences, University of Calabar, Cross River State n Nigeria.',
      imagePath: profEneObongImg
    },
    {
      name: 'Barrister C. Onubogu',
      title: 'Board Member',
      bio: 'Bio',
      imagePath: barristerOnuboguImg
    },
    {
      name: 'Onyeka Onwenu (MFR)',
      title: 'Board Member (Late)',
      bio: 'Nigerian Singer-songwriter and Actress. She served on the Board of PACIEH with passion for the poor and vulnerable populations in Nigeria and West Africa. A well Human right and social activist and Journalist. She died on 30th July 2024',
      imagePath: onyekaOnwenuImg
    },
    {
      name: 'Dr. Ngozi Njepuome',
      title: 'Board Member',
      bio: 'Dr. Ngozi Njepuome is a consultant physician of over 40 years, a seasoned Public Health Specialist and an International Health Consultant. She occupied leadership positions at FMOH.',
      imagePath: drNjepuomeImg
    }
  ],
  secretary: {
    name: 'Professor Angela Ekwunife',
    title: 'Secretary',
    bio: 'Professor Chinyelu Angela Ekwunife is a distinguished Professor of Public Health, Parasitology, and Epidemiology at Nnamdi Azikiwe University. With over two decades of experience, she has significantly contributed to eradicating urogenital schistosomiasis, a success documented in "Under the Big Tree." Professor Ekwunife holds influential leadership roles, serving as the first female Associate Provost (Sciences) at her university and as the National Treasurer and a Fellow of the Parasitology and Public Health Society of Nigeria. Her global involvement includes being a Management Board member of the African Research Network for Neglected Tropical Diseases and a key WHO Social Innovation in Health Initiative Research Team member.',
    imagePath: profEkwunifeImg
  },
  adminOfficer: {
    name: 'Mrs Amarachi',
    title: 'Assistant Admin Officer',
    imagePath: mrsAmarachiImg
  },
  technicalAdvisory: [
    {
      name: 'Professor Andy Crump',
      title: 'Technical Advisor',
      imagePath: profCrumpImg
    },
    {
      name: 'Professor H. Ene-Obong',
      title: 'Technical Advisor',
      imagePath: profEneObongImg
    },
    {
      name: 'Professor Nkadi Onyegegbu',
      title: 'Technical Advisor',
      imagePath: profOnyegegbuImg
    },
    {
      name: 'Professor Joseph Okeibunor',
      title: 'Technical Advisor',
      imagePath: profOkeibunorImg
    },
    {
      name: 'Professor Angela Ekwunife',
      title: 'Technical Advisor',
      bio: 'Professor Chinyelu Angela Ekwunife is a distinguished Professor of Public Health, Parasitology, and Epidemiology at Nnamdi Azikiwe University. With over two decades of experience, she has significantly contributed to eradicating urogenital schistosomiasis, a success documented in "Under the Big Tree." Professor Ekwunife holds influential leadership roles, serving as the first female Associate Provost (Sciences) at her university and as the National Treasurer and a Fellow of the Parasitology and Public Health Society of Nigeria. Her global involvement includes being a Management Board member of the African Research Network for Neglected Tropical Diseases and a key WHO Social Innovation in Health Initiative Research Team member.',
      imagePath: profEkwunifeImg
    },
    {
      name: 'Dr. Chukwudi Michael Egbuche',
      title: 'Technical Advisor',
      bio: 'Dr. Chukwudi Michael Egbuche is an Associate Professor and Head of the Department of Parasitology and Entomology at Nnamdi Azikiwe University, Nigeria. He has a significant background in public health initiatives across Nigeria, including leading the first Lymphatic Filariasis Assessment Survey in 2022 and serving as an NTD Coordinator. His experience also encompasses monitoring deworming campaigns, conducting research on Ivermectin\'s benefits, and acting as a WHO Independent Monitor for immunization programs. Dr. Egbuche has also contributed to mapping disease vectors like Simulium damnosum.',
      imagePath: drEgbucheImg
    },
    {
      name: 'Dr. Emmanuel Asiegbu',
      title: 'Technical Advisor',
      bio: 'Professor Emmanuel Chidubem Asiegbu is a distinguished scholar from Anambra State, Nigeria, specializing in Educational Planning and the Economics of Education. He has been teaching at Nnamdi Azikiwe University, Awka, since 2010. His research encompasses gender issues, conflict resolution, entrepreneurship, education finance, and quality assurance. Administratively, he serves as Sub-Dean of the Faculty of Education and holds several other significant positions within the university and professional organizations.',
      imagePath: drAsiegbuImg
    },
    {
      name: 'OBIAKOR UGOCHUKWU ANTHONY',
      title: 'Technical Advisor',
      bio: 'A Researcher and Lecturer in the Department of Parasitology and Entomology, Nnamdi Azikiwe University Awka Anambra state',
      imagePath: obiakorImg
    }
  ]
};

function Team() {
  const [selectedMember, setSelectedMember] = useState(null);
  const [isBioOpen, setIsBioOpen] = useState(false);

  const handleOpenBio = (member) => {
    setSelectedMember(member);
    setIsBioOpen(true);
  };

  const handleCloseBio = () => {
    setIsBioOpen(false);
    setSelectedMember(null);
  };

  return (
    <>
      <Helmet>
        <title>Our Team | PACIEH</title>
        <meta name="description" content="Meet the dedicated team behind PACIEH's mission to transform lives through education and healthcare initiatives." />
      </Helmet>

      <PageHeader
        title="Leadership & Governance"
        subtitle="Meet the seasoned public health pioneers, educators, researchers, and technical advisors driving sustainable community impact across Africa."
      />

      {/* Board of Trustees Section */}
      <section className="py-16">
        <div className="container">
          <h2 className="text-3xl font-bold text-center text-pacieh-blue mb-12">
            Board of Trustees
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.boardOfTrustees.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <div className="aspect-w-4 aspect-h-3">
                  <img
                    src={member.imagePath}
                    alt={member.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = '/placeholder-profile.jpg';
                    }}
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-pacieh-blue mb-2">
                    {member.name}
                  </h3>
                  <p className="text-pacieh-green font-medium mb-4">
                    {member.title}
                  </p>
                  {member.role && (
                    <p className="text-gray-600 mb-4">{member.role}</p>
                  )}
                  {member.bio && (
                    <div className="mt-4">
                      <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                        {member.bio}
                      </p>
                      <button
                        onClick={() => handleOpenBio(member)}
                        className="text-pacieh-blue hover:text-pacieh-green font-medium transition-colors duration-200"
                      >
                        Read Full Bio
                      </button>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Secretary and Admin Section */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <div className="aspect-w-4 aspect-h-3">
                <img
                  src={teamMembers.secretary.imagePath}
                  alt={teamMembers.secretary.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/placeholder-profile.jpg';
                  }}
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-pacieh-blue mb-2">
                  {teamMembers.secretary.name}
                </h3>
                <p className="text-pacieh-green font-medium mb-4">
                  {teamMembers.secretary.title}
                </p>
                {teamMembers.secretary.bio && (
                  <div className="mt-4">
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                      {teamMembers.secretary.bio}
                    </p>
                    <button
                      onClick={() => handleOpenBio(teamMembers.secretary)}
                      className="text-pacieh-blue hover:text-pacieh-green font-medium transition-colors duration-200"
                    >
                      Read Full Bio
                    </button>
                  </div>
                )}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <div className="aspect-w-4 aspect-h-3">
                <img
                  src={teamMembers.adminOfficer.imagePath}
                  alt={teamMembers.adminOfficer.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/placeholder-profile.jpg';
                  }}
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-pacieh-blue mb-2">
                  {teamMembers.adminOfficer.name}
                </h3>
                <p className="text-pacieh-green font-medium mb-4">
                  {teamMembers.adminOfficer.title}
                </p>
                {teamMembers.adminOfficer.bio && (
                  <div className="mt-4">
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                      {teamMembers.adminOfficer.bio}
                    </p>
                    <button
                      onClick={() => handleOpenBio(teamMembers.adminOfficer)}
                      className="text-pacieh-blue hover:text-pacieh-green font-medium transition-colors duration-200"
                    >
                      Read Full Bio
                    </button>
                  </div>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Technical Advisory Committee Section */}
      <section className="py-16">
        <div className="container">
          <h2 className="text-3xl font-bold text-center text-pacieh-blue mb-12">
            Technical Advisory Committee
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.technicalAdvisory.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <div className="aspect-w-4 aspect-h-3">
                  <img
                    src={member.imagePath}
                    alt={member.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = '/placeholder-profile.jpg';
                    }}
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-pacieh-blue mb-2">
                    {member.name}
                  </h3>
                  <p className="text-pacieh-green font-medium mb-4">
                    {member.title}
                  </p>
                  {member.bio && (
                    <div className="mt-4">
                      <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                        {member.bio}
                      </p>
                      <button
                        onClick={() => handleOpenBio(member)}
                        className="text-pacieh-blue hover:text-pacieh-green font-medium transition-colors duration-200"
                      >
                        Read Full Bio
                      </button>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Popup */}
      {selectedMember && (
        <BioPopup
          isOpen={isBioOpen}
          onClose={handleCloseBio}
          member={selectedMember}
        />
      )}
    </>
  );
}

export default Team; 